export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8866.6f16c6e7.jpg";